
<div class="kpi-box"
    id="{{kpi_data.DIAG_MSG}}"
    #{{kpi_data.DIAG_MSG}}
    [ngStyle]="{'background': kpi_data.DIAG_MSG== kpiFilter ? '#FFF4E3' : 'white'}">
    <div class="kpi-content">
    <span class=" alter-icon Appkit4-icon {{kpi_data.icon}}"
    [ngClass]="{'alter-icon': kpi_data.DIAG_MSG=='Critical',
                'info': kpi_data.DIAG_MSG=='Informational',
            'all-icon':kpi_data.DIAG_MSG=='All'}"
   ></span>
    <span class="title">{{kpi_data.DIAG_MSG}} Diagnostics</span>
    <span  class="amount float-right">
        @if (kpi_data.EFFECTED_COUNT !=0 && kpi_data.DIAG_MSG == 'All') {
<span style="color: #D04A02;"  [ap-tooltip] [tooltipContent]="allEffected" [direction]="'bottom'">{{kpi_data.EFFECTED_COUNT}}</span>
}
        @if (kpi_data.EFFECTED_COUNT !=0 && kpi_data.DIAG_MSG == 'Critical') {
<span style="color: #D04A02;"  [ap-tooltip] [tooltipContent]="criticalEffected" [direction]="'bottom'">{{kpi_data.EFFECTED_COUNT}}</span>
}
        @if (kpi_data.EFFECTED_COUNT !=0 && kpi_data.DIAG_MSG == 'Informational') {
<span style="color: #D04A02;"  [ap-tooltip] [tooltipContent]="InfoEffected" [direction]="'bottom'">{{kpi_data.EFFECTED_COUNT}}</span>
}
        @if (kpi_data.EFFECTED_COUNT !=0) {
<span> of </span>
}
        <!-- <span> {{kpi_data.COUNT}}</span> -->
        @if (kpi_data.DIAG_MSG=='All') {
<span [ap-tooltip] [tooltipContent]="allCount" [direction]="'top'"> {{kpi_data.COUNT}}</span>
}
        @if (kpi_data.DIAG_MSG=='Critical') {
<span [ap-tooltip] [tooltipContent]="criticalTotal" [direction]="'top'"> {{kpi_data.COUNT}}</span>
}
        @if (kpi_data.DIAG_MSG=='Informational') {
<span [ap-tooltip] [tooltipContent]="InfoTotal" [direction]="'top'"> {{kpi_data.COUNT}}</span>
}

    </span>
    </div>
</div>
<ng-template #allCount>
    <div class="tooltip-inner ap-p-spacing-3 d-block a-min-width-300">
        <div class="a-font-sm customize-tooltip-text font-weight-normal text-left ap-mt-spacing-2">
            This is the count of all resolved and unresolved
            diagnostics. It is a mixture of Critical
            and Informational diagnostics.
        </div>
    </div>
</ng-template>
<ng-template #allEffected>
    <div class="tooltip-inner ap-p-spacing-3 d-block a-min-width-300">
        <div class="a-font-sm customize-tooltip-text font-weight-normal text-left ap-mt-spacing-2">
            This is the count of unresolved
            diagnostics. It is a mixture of Critical
            and Informational diagnostics.
        </div>
    </div>
</ng-template>
<ng-template #criticalTotal>
    <div class="tooltip-inner ap-p-spacing-3 d-block a-min-width-300">
        <div class="a-font-sm customize-tooltip-text font-weight-normal text-left ap-mt-spacing-2">
            This is the count of all resolved and
            unresolved Critical diagnostics.
         </div>
    </div>
</ng-template>
<ng-template #criticalEffected>
    <div class="tooltip-inner ap-p-spacing-3 d-block a-min-width-300">
        <div class="a-font-sm customize-tooltip-text font-weight-normal text-left ap-mt-spacing-2">
            This is the count of all unresolved
            Critical diagnostics.
        </div>
    </div>
</ng-template>
<ng-template #InfoTotal>
    <div class="tooltip-inner ap-p-spacing-3 d-block a-min-width-300">
        <div class="a-font-sm customize-tooltip-text font-weight-normal text-left ap-mt-spacing-2">
            This is the count of all resolved and
            unresolved Informational diagnostics.
        </div>
    </div>
</ng-template>
<ng-template #InfoEffected>
    <div class="tooltip-inner ap-p-spacing-3 d-block a-min-width-300">
        <div class="a-font-sm customize-tooltip-text font-weight-normal text-left ap-mt-spacing-2">
            This is the count of all unresolved
            Informational diagnostics.
        </div>
    </div>
</ng-template>
